import cookie from 'js-cookie';

export const TOKEN = 'access_token';
export const TOKEN_EXPIRES_AT = 'token_expires_at';
export const REFRESH_TOKEN = 'refresh_token';
export const APP_URL = process.env.APP_URL || 'http://localhost:3000';

export const AI_TOKEN = 'access_token';
export const AI_TOKEN_EXPIRES_AT = 'token_expires_at';
export const AI_REFRESH_TOKEN = 'refresh_token';

export function AuthHeader(headers=null) {
	
	return {
		'Content-Type': 'application/json',
		Authorization: 'Bearer ' + cookie.get(TOKEN),
		...headers || {} 
	}
}

export function AIAuthHeader(headers=null) {
	
	return {
		'Content-Type': 'application/json',
		"x-hyvid-token": `Bearer ${cookie.get(TOKEN)}`,
		...headers || {} 
	}
  }